import { createSlice } from "@reduxjs/toolkit"

const TENANT_STORAGE_KEY = "tenantId"

const initialState = {
  tenantId: localStorage.getItem(TENANT_STORAGE_KEY) || null,
  tenantName: null,
  tenantSettings: {},
  availableTenants: [],
  loading: false,
  error: null,
}

const tenantSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    setTenant(state, action) {
      const { tenantId, tenantName, tenantSettings } = action.payload
      state.tenantId = tenantId
      state.tenantName = tenantName || null
      state.tenantSettings = tenantSettings || {}
      state.error = null
      localStorage.setItem(TENANT_STORAGE_KEY, tenantId)
    },
    setAvailableTenants(state, action) {
      state.availableTenants = action.payload || []
    },
    clearTenant(state) {
      state.tenantId = null
      state.tenantName = null
      state.tenantSettings = {}
      state.error = null
      localStorage.removeItem(TENANT_STORAGE_KEY)
    },
    setTenantError(state, action) {
      state.error = action.payload
      state.loading = false
    },
    setTenantLoading(state, action) {
      state.loading = action.payload
    },
  },
})

export const {
  setTenant,
  setAvailableTenants,
  clearTenant,
  setTenantError,
  setTenantLoading,
} = tenantSlice.actions

export const selectTenantId = state => state.Tenant?.tenantId
export const selectTenantName = state => state.Tenant?.tenantName
export const selectTenantSettings = state => state.Tenant?.tenantSettings
export const selectAvailableTenants = state => state.Tenant?.availableTenants ?? []

export default tenantSlice.reducer
